import { getCouponInfo } from "./recurly.functions";


export const cardNumberStyle = ()=>{return ({
    inputType: 'mobileSelect',
    format: true,
    style: {
        fontFamily: "Nunito",
        fontSize: "0.875em",
        fontColor: "#373737",
        fontSmoothing: "antialiased",
        border: "1px solid rgba(55, 55, 55, 0.15)",
        placeholder: { 
            content: 'Card Number',
            color: '#AFAFAF'
        },
        invalid: {
            fontColor: 'red'
        },
        input: {
            paddingLeft: "0"
        }
    }
})};
export const cardMonthStyle = ()=>{return ({
    inputType: 'select',
    format: true,
    style: {
        fontFamily: "Nunito",
        fontColor: "#373737",
        fontSize: "0.875em",
        fontSmoothing: "antialiased",
        border: "1px solid rgba(55, 55, 55, 0.15)",
        placeholder: {
            content: 'Month',
            color: '#AFAFAF'
        },
        invalid: {
            fontColor: 'red'
        }
    }
})};
export const cardYearStyle = ()=>{return ({
    inputType: 'select',
    format: true,
    style: {
        fontFamily: "Nunito",
        fontSize: "0.875em",
        fontColor: "#373737",
        fontSmoothing: "antialiased",
        border: "1px solid rgba(55, 55, 55, 0.15)",
        placeholder: {
            content: 'Year',
            color: '#AFAFAF'
        },
        invalid: {
            fontColor: 'red'
        }
    }
})};
export const cardCvvStyle = ()=>{return ({
    inputType: 'mobileSelect',
    format: true,
    style: {
        fontFamily: "Nunito",
        fontSize: "0.875em",
        fontColor: "#373737",
        fontSmoothing: "antialiased",
        border: "1px solid rgba(55, 55, 55, 0.15)",
        placeholder: {
            content: 'Security Code (CVV)',
            color: '#AFAFAF'
        },
        invalid: {
            fontColor: 'red'
        }
    }
})};

export const planTextSelector = (plan_code_from_url, promo) => {
    let text;
    if (plan_code_from_url.includes("otb")) text = "<ul><li>One-time purchase</li><li>5 exclusive products</li><li>Make memories & get pampered</li></ul>";
    else {
        if(promo === "ttm50off") text = "<ul><li>$21 first box, renews <div id='box-price' class='text blurred' style='display: inline;'>-----</div> per box</li>"
        else if(promo === "ttm25off") text = "<ul><li>$31.49 first box, renews <div id='box-price' class='text blurred' style='display: inline;'>-----</div> per box</li>"
        else if(promo === "ttm30off") text = "<ul><li>$29 first box, renews <div id='box-price' class='text blurred' style='display: inline;'>-----</div> per box</li>"
        else text = "<ul><li><div id='box-price' class='text blurred' style='display: inline;'>-----</div> per box</li>"
        text += `<li>5-6 full-size products per box up to $150 in value</li>`;
        text += `<li>Automatically stops after the last theme<div id="popup-inside" style="cursor: pointer;">i</div></li>`;        
        text += "<li>Pause or cancel anytime</li></ul>";        
    }
    return text;
  }

  export const planNameSelector = (plan_code_from_url) => {
    let text;
    if (plan_code_from_url.includes("otb")) text = '1st Trimester "Congrats mama-to-be" Box';
    else if (plan_code_from_url.includes("e1mi") ) text = "INTRO MONTHLY PLAN";
    else if (plan_code_from_url.includes("e1m") ) text = "MONTHLY PLAN";
    else if (plan_code_from_url.includes("e2m") ) text = "EVERY 2 MONTHS PLAN";
    return text;
  }

  export const errorTextSelector = (error_obj) => {
    let text = error_obj.toString();
    if(text.includes("billing address does not match")){
        text = 'The billing address does not match. Please click "+ Enter new billing info" and enter details that match your credit card account.';
    }
    return text;
  }

  export const promoTextSelector = async (givenPromoCode) =>{
    let promoCode = givenPromoCode.toLowerCase();
    try{
        let couponInfo = await getCouponInfo(promoCode)
        if(couponInfo.success){
            return `Promo: ${couponInfo.coupon_name.trim()}`;
        }else {
            return `Code: ${promoCode.toUpperCase()}`;
        }
    } catch(error) {
        return `Code: ${promoCode.toUpperCase()}`;
    }
  }


